import {ComponentRef, Injectable, ViewContainerRef} from '@angular/core';
import {ToasNeoComponent} from "../../componentes/util/notificaciones/toas-neo/toas-neo.component";
import {AlertDialogComponent} from "../../componentes/util/notificaciones/alert-dialog/alert-dialog.component";
import {ClsConfig} from "../../util/cls-config";
import { OverlaySettings, VerticalAlignment } from '@infragistics/igniteui-angular/core';
import {WaitDialogComponent} from "../../componentes/util/notificaciones/wait-dialog/wait-dialog.component";
import {QuestionDialogComponent} from "../../componentes/util/notificaciones/question-dialog/question-dialog.component";
import {
  AlertDialogPromiseComponent
} from "../../componentes/util/notificaciones/alert-dialog-promise/alert-dialog-promise.component";
import {
  WaitDialogCustomComponent
} from "../../componentes/util/notificaciones/wait-dialog-custom/wait-dialog-custom.component";
import {INeodataBtns} from "../models/interfaces/generico-interface";
import {
  AlertDialogCustomPromiseComponent
} from "../../componentes/util/notificaciones/alert-dialog-custom-promise/alert-dialog-custom-promise.component";
import {
  AiLoadingOverlayComponent
} from '../../componentes/util/notificaciones/ai-loading-overlay/ai-loading-overlay.component';

@Injectable({
  providedIn: 'root'
})
export class TipoMensajesService extends ClsConfig {
  private container!: ViewContainerRef;
  private componentRefWait: ComponentRef<WaitDialogComponent>;
  private componentRefWaitCustom: ComponentRef<WaitDialogCustomComponent>;
  private componentRefAILoading: ComponentRef<AiLoadingOverlayComponent> | null = null;
  private pendingAiLoading = 0;

  constructor() {
    super();
  }

  public setContainer(container: ViewContainerRef) {
    this.container = container;
  }

  /**
   * componente generico Toast
   * @param mensaje = texto a mostrar
   * @param tiempo =  por default 3000
   * @param autoHide = si deseas que se oculte en automatico, por default es auto
   * @param posicion = por default bottom, puede cambiarlo: top, middle
   */
  public mostrarToast(mensaje: string, tiempo: number = 3000, autoHide = true, posicion = VerticalAlignment.Bottom) {
    try {
      const componentRef = this.container.createComponent(ToasNeoComponent);
      componentRef.instance.abrir(mensaje, tiempo, autoHide, posicion);
      // Suscripción para limpieza de memoria al cerrar
      const sub = componentRef.instance.evtCerrado.subscribe(() => {
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        componentRef.destroy();         // 🔁 Limpieza
      });
    } catch (e) {
      alert(e.message);
    }
  }

  /**
   * componente generico WaitDialog
   * @param mensaje = texto a mostrar
   * @param titulo = por default NEODATA PU NUBE+ nombre del sistema, pero es editable
   * @param icono = por default check, se puede cambiar al icono que se encuentre en esta URL: https://fonts.google.com/icons?selected=Material+Icons+Sharp&icon.set=Material+Symbols
   */
  public mostrarWaitDialog(mensaje: string, titulo: string = this.gTituloSistema(), icono: string = 'check') {
    try {
      this.componentRefWait = this.container.createComponent(WaitDialogComponent);
      this.componentRefWait.instance.abrir(mensaje, titulo, icono, this.dialogOverlaySettings);
    } catch (e) {
      alert(e.message);
    }
  }

  /**
   * Sirve para cerrar el componente generico WaitDialog
   */
  public cerrarWaitDialog() {
    if (this.componentRefWait) {
      this.componentRefWait.instance.cerrar();
      // Suscripción para limpieza de memoria al cerrar
      const sub = this.componentRefWait.instance.evtCerrado.subscribe(() => {
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        this.componentRefWait.destroy();         // 🔁 Limpieza
      });
    }
  }

  /**
   * componente generico AlertDialog
   * @param mensaje = mensaje a mostrar
   * @param icono = por default info, se puede cambiar al icono que se encuentre en esta URL: https://fonts.google.com/icons?selected=Material+Icons+Sharp&icon.set=Material+Symbols
   * @param titulo = por default NEODATA PU NUBE+ nombre del sistema, pero es editable
   * @param textLeftButton = default OK, es editable
   */
  public mostrarMsg(mensaje: string, icono: string = 'info', titulo: string = this.gTituloSistema(), textLeftButton: string = 'OK') {
    try {
      const componentRef = this.container.createComponent(AlertDialogComponent);
      componentRef.instance.abrir(mensaje, titulo, icono, textLeftButton, this.dialogOverlaySettings);
      // Suscripción para limpieza de memoria al cerrar
      const sub = componentRef.instance.evtCerrado.subscribe(() => {
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        componentRef.destroy();         // 🔁 Limpieza
      });
    } catch (e) {
      alert(e.message);
    }
  }

  // public mostrarMsgPersonalizado(msjError: string, linea: number, metodo: string, titulo: string = this.tituloSistema(), icono: string = 'check', textLeftButton: string = 'OK') {
  //   try {
  //     const componentRef = this.container.createComponent(AlertDialogComponent);
  //     // Procesar mensaje de error
  //     let mensajeFormateado: string;
  //     const msjLower = msjError.toLowerCase();
  //     if (msjLower.includes('la sesion a caducado')) {
  //       msjError = `Usted ya inicio sesión en otro sistema de Neodata, por la cual no puede ocupar NEODATA PU NUBE+.
  //                 <br/>Para ocupar nuevamente NEODATA PU NUBE+ necesita iniciar sesión.`;
  //     }
  //     mensajeFormateado = `${msjError}<br /> Línea: ${linea} Método: ${metodo}`;
  //     componentRef.instance.abrir(mensajeFormateado, titulo, icono, textLeftButton, this.dialogOverlaySettings);
  //     // Suscripción para limpieza de memoria al cerrar
  //     const sub = componentRef.instance.evtCerrado.subscribe(() => {
  //       sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
  //       componentRef.destroy();         // 🔁 Limpieza
  //     });
  //   } catch (e) {
  //     alert(e.message);
  //   }
  // }

  /**
   * compoenente generico QuestionDialog
   * @param callback = valor que regresa al elegir aceptar o cancelar
   * @param mensaje = mensaje a mostrar
   * @param titulo = por default NEODATA PU NUBE+ nombre del sistema, pero es editable
   * @param icono = por default help, se puede cambiar al icono que se encuentre en esta URL: https://fonts.google.com/icons?selected=Material+Icons+Sharp&icon.set=Material+Symbols
   */
  public mostrarQuestion(callback: (resp: boolean) => void | Promise<void>, mensaje: string, titulo: string = this.gTituloSistema(), icono: string = 'help') {
    try {
      const componentRef = this.container.createComponent(QuestionDialogComponent);
      componentRef.instance.abrir(mensaje, titulo, icono, this.dialogOverlaySettings);
      // Suscripción para limpieza de memoria al cerrar
      const sub = componentRef.instance.evtResuelto.subscribe(async (resp: boolean) => {
        await callback(resp);
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        componentRef.destroy();         // 🔁 Limpieza
      });
    } catch (e) {
      alert(e.message);
    }
  }

  public mostrarMsgPromise(callback: (resp: boolean) => void | Promise<void>, mensaje: string, titulo: string = this.gTituloSistema(), icono: string = 'check', textLeftButton: string = 'OK') {
    try {
      const componentRef = this.container.createComponent(AlertDialogPromiseComponent);
      componentRef.instance.abrir(mensaje, titulo, icono, textLeftButton, this.dialogOverlaySettings);
      const sub = componentRef.instance.evtResuelto.subscribe(async (resp: boolean) => {
        await callback(resp);
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        componentRef.destroy();         // 🔁 Limpieza
      });
    } catch (e) {
      alert(e.message);
    }
  }

  public mostrarMasMsgsCustomizado(mensaje: string, titulo: string = this.gTituloSistema(), icono: string = 'check', overlaySettings: OverlaySettings = this.dialogOverlaySettings): WaitDialogCustomComponent {
    try {
      this.componentRefWaitCustom = this.container.createComponent(WaitDialogCustomComponent);
      this.componentRefWaitCustom.instance.abrir(mensaje, titulo, icono, overlaySettings);
      return this.componentRefWaitCustom.instance;
    } catch (e) {
      alert(e.message);
    }
  }

  /**
   * Funcion que se ocupara para cambiar mensaje2, cuando se trabaja con la funcion mostrarMasMsgsCustomizado
   * @param mensaje2
   */
  public actualizarMensaje2(mensaje2: string) {
    if (this.componentRefWaitCustom) {
      this.componentRefWaitCustom.instance.MENSAJE2 = mensaje2;
    }
  }

  public cerrarMasMsgsCustomizado() {
    // Suscripción para limpieza de memoria al cerrar
    if (this.componentRefWaitCustom) {
      this.componentRefWaitCustom.instance.cerrar();
      const sub = this.componentRefWaitCustom.instance.evtCerrado.subscribe(() => {
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        this.componentRefWaitCustom.destroy();         // 🔁 Limpieza
      });
    }
  }

  /**
   * compoenente generico QuestionDialog
   * @param callback = valor que regresa al elegir cualquier opcion del arreglo de botones
   * @param mensaje = mensaje a mostrar
   * @param titulo = por default NEODATA PU NUBE+ nombre del sistema, pero es editable
   * @param icono = por default help, se puede cambiar al icono que se encuentre en esta URL: https://fonts.google.com/icons?selected=Material+Icons+Sharp&icon.set=Material+Symbols
   * @param arrayBtn = arreglo de botones
   */
  public mostrarQuestionCustomPromise(callback: (resp: string) => void | Promise<void>, mensaje: string, titulo: string = this.gTituloSistema(), icono: string = 'check', arrayBtn: INeodataBtns[] = []) {
    try {
      const componentRef = this.container.createComponent(AlertDialogCustomPromiseComponent);
      componentRef.instance.abrir(mensaje, titulo, icono, arrayBtn, this.dialogOverlaySettings);
      // Suscripción para limpieza de memoria al cerrar
      const sub = componentRef.instance.evtResuelto.subscribe(async (resp: string) => {
        await callback(resp);
        sub.unsubscribe();     // 🔁 Evita fuga de memoria del EventEmitter
        componentRef.destroy();         // 🔁 Limpieza
      });
    } catch (e) {
      alert(e.message);
    }
  }

  public mostrarAiLoading() {
    try {
      this.pendingAiLoading += 1;
      if (this.pendingAiLoading > 1) {
        return;
      }

      this.componentRefAILoading = this.container.createComponent(AiLoadingOverlayComponent);
    } catch (e) {
      alert(e.message);
    }
  }

  public cerrarAiLoading() {
    if (this.pendingAiLoading > 0) {
      this.pendingAiLoading -= 1;
    }

    if (this.pendingAiLoading > 0) {
      return;
    }

    if (this.componentRefAILoading) {
      this.componentRefAILoading.destroy();
      this.componentRefAILoading = null;
    }
  }
}
